(function ($) {
  const element = $(".js-ai-trade-search-wrapper");

  // Initialize tradePrefilled flag on page load
  let tradePrefilled =
    element.data("trade-prefilled") === true &&
    !!element.find(".js-trade-input").val();

  const search = function (value, vertical, scope) {
    element.find(".ai-results").hide();
    element.find(".js-ai-trade-search").blur();

    const resultsElem = element
      .find(".ai-results .js-results-options")
      .html("");

    if (value.trim() === "") {
      showError("Please describe your business.");

      return;
    }

    hideError();
    element.find(".ai-loading").show();

    const strategy = $(".js-ai-trade-search").data("strategy");
    const showTradeDefinitionParam = element.data("show-trade-definition");
    const showTradeDefinition = showTradeDefinitionParam !== false
    scope = encodeURIComponent(scope);

    fetch(
      `/trade_search?${new URLSearchParams({
        q: value,
        vertical,
        primary_detail: true,
        search_scope: scope,
        show_trade_definitions: showTradeDefinition,
        ai_results: true,
        ai_strategy: strategy,
        path: window.location.pathname,
      })}`,
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        showError(
          "We were unable to find a business that matches your description. Try again using different words.",
        );

        throw new Error("The trade search API call failed.");
      })
      .then((response) => {
        if (response.results.length === 0) {
          showError("We are unable to find a match for your search.");

          return;
        }

        element.find(".js-trade-input").data("search-id", response.search_id);

        for (let x = 0; x < response.results.length; x += 1) {
          const item = $("<label>")
            .addClass("radio")
            .append(
              $('<input type="radio">')
                .data("option-number", x + 1)
                // Needed to switch between verticals
                .data(
                  "supported-verticals",
                  response?.results?.[x]?.supported_verticals,
                )
                .data("vertical", response.results[x].vertical)
                .val(response.results[x].value),
            )
            .append(
              `<span class='radio-label'>` +
                `<span class='trade-name'>${response.results[x].value}</span>${
                  response.results[x].definition
                    ? `<span class='trade-definition'>${response.results[x].definition}</span>`
                    : ""
                }</span>`,
            );

          resultsElem.append(item);
        }

        element.find(".ai-loading").hide();
        element.find(".ai-results").show();

        applyReadMore();
        readMoreToggle();

        window.addEventListener("resize", debounce(applyReadMore, 100));
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  };

  const showError = function (error) {
    element.parent().addClass("error");
    element.find(".js-ai-trade-search").addClass("error");

    element.find(".ai-loading").hide();
    element.find(".js-error").text(error).css("display", "block");
  };

  const hideError = function () {
    element.parent().removeClass("error");
    element.find(".js-ai-trade-search").removeClass("error");

    element.find(".js-error").hide();
  };

  const getURLParam = function (param) {
    return new URLSearchParams(window.location.search).get(param);
  };

  const shouldRedirect = function (
    principalVertical,
    currentVertical,
    supportedVerticals,
    searchScope,
  ) {
    const redirectUrl = element.data("redirect-url");

    if (redirectUrl === null || redirectUrl === undefined) {
      return false;
    }

    // excluded because we don't want a redirection from coverage selection for business reasons
    if (searchScope === "Coverage selection") {
      return false;
    }
    // doing this for Business Owners Policy to match the existing logic for legacy trade selector
    const isExcludedVertical =
      currentVertical === "business_owners_policy" &&
      principalVertical !== "business_owners_policy";

    if (isExcludedVertical) {
      return !(
        supportedVerticals &&
        supportedVerticals.includes("business_owners_policy")
      );
    }

    return currentVertical !== principalVertical;
  };

  $(document).on("keypress", ".js-ai-trade-search", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();

      const vertical = element.data("vertical");
      const searchScope = element.data("search-scope");
      search($(this).val(), vertical, searchScope);
    }

    // safety navigator added as tracking in development is disabled and this can cause unwanted errors
    window?.snowplowHelper?.trackFrontofficeStructEvent({
      category: "marketing",
      action: "ai_trade_selector_typed",
      label: "ai_trade_selector",
      property: $(this).val(),
      serviceChannelIdentifier: $('meta[name="site"]').attr("content"),
    });
  });

  $(document).on("click", ".js-ai-search-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const element = $(this).closest(".js-ai-trade-search-wrapper");
    const vertical = element.data("vertical");
    const searchScope = element.data("search-scope");
    const inputValue = element.find(".js-ai-trade-search").val();
    search(inputValue, vertical, searchScope);
  });

  $(document).on("click", ".ai-results label", function (e) {
    e.stopPropagation();
    e.preventDefault();

    const input = $(this).find("input");
    const trade = input.val();
    const principalVertical = input.data("vertical");
    const currentVertical = element.data("vertical");
    const supportedVerticals = input.data("supported-verticals");
    const searchScope = element.data("search-scope");
    const businessUnit = element.data("business-unit");
// Store pre_filled_source in sessionStorage for trade added in coverage selection
    if (
      searchScope === "Coverage selection" &&
      businessUnit === "simplybusiness_us"
    ) {
      sessionStorage.setItem("preFilledSource", "trade_selector_pre_app");
    }
    if (
      shouldRedirect(
        principalVertical,
        currentVertical,
        supportedVerticals,
        searchScope,
      )
    ) {
      const journeyId = window.location.pathname.split("/").pop();
      const affclie = getURLParam("AFFCLIE");

      let url = `/route_trade?vertical=${encodeURIComponent(
        principalVertical,
      )}&trade=${encodeURIComponent(
        trade,
      )}&journey_id=${encodeURIComponent(
        journeyId
      )}&original_vertical=${encodeURIComponent(currentVertical)}`;

      if (affclie) url += `&AFFCLIE=${encodeURIComponent(affclie)}`;

      const redirectionUrl = `${window.location.origin}${url}`;

      window.location.href = redirectionUrl;
    }

    element.find(".js-trade-input").val(trade);
    element.find(".js-trade-input").trigger("change");

    // Reset prefilled flag after user selection
    tradePrefilled = false;

    element.find(".answer").text(trade);

    element.parent().removeClass("state-search").addClass("state-selected");

    element.find(".ai-search-input-wrapper").hide();

    // safety navigator added as tracking in development is disabled and this can cause unwanted errors
    window?.snowplowHelper?.trackFrontofficeStructEvent({
      category: "marketing",
      action: "ai_trade_selector_option_clicked",
      label: "ai_trade_selector_option",
      property: input.data("option-number"),
      serviceChannelIdentifier: $('meta[name="site"]').attr("content"),
    });

    // Validate trade before triggering event
    // Return early if trade is blank or whitespace only
    if (!trade || trade.toString().trim() === '') {
      return;
    }
    
    // For US trades, check if trade has been properly validated (has state-selected class)
    const isUSPage = businessUnit === "simplybusiness_us";
    const isValidatedTrade = element.parent().hasClass("state-selected");
    
    // If this is a US trade and it hasn't been validated, don't fire the event
    if (isUSPage && !isValidatedTrade) {
      return;
    }
    
    const tradeResults = [];
    element
      .find('.ai-results .js-results-options input[type="radio"]')
      .each(function () {
        tradeResults.push($(this).val());
      });

    const selectedIndex = tradeResults.indexOf(trade);

    window.EventTracker.trigger(
      "primary_detail_selected",
      trade,
      false,
      element.find(".js-trade-input").data("search-id"),
      null, // redirectedFromVertical
      businessUnit,
      searchScope,
      selectedIndex,
      tradePrefilled
    );
  });

  $(document).on("click", ".js-ai-change", function () {
    $(".trade-search").removeClass("state-selected").addClass("state-search");

    element.find(".ai-search-input-wrapper").show();
  });
})(window.jQuery);

const applyReadMore = () => {
  const tradeDefinitions = document.querySelectorAll(".trade-definition");

  tradeDefinitions.forEach((tradeDefinition) => {
    const readMore = document.createElement("button");
    readMore.classList.add("read-more");
    readMore.innerText = "Read more";
    const parentLabel = tradeDefinition.closest(".radio-label");
    parentLabel.appendChild(readMore);

    if (
      tradeDefinition.offsetHeight < tradeDefinition.scrollHeight ||
      tradeDefinition.offsetWidth < tradeDefinition.scrollWidth
    ) {
      parentLabel.querySelector(".read-more").classList.add("show");
    } else {
      parentLabel.querySelector(".read-more").classList.remove("show");
    }
  });
};

// TODO: add tracking
const readMoreToggle = () => {
  document.querySelectorAll(".read-more").forEach((readMoreButton) => {
    readMoreButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const readMoreLink = e.target;
      const parentTradeDefinition = readMoreLink
        .closest(".radio-label")
        .querySelector(".trade-definition");
      parentTradeDefinition.classList.toggle("expanded");

      readMoreLink.innerText = parentTradeDefinition.classList.contains(
        "expanded",
      )
        ? "Read less"
        : "Read more";

      trackReadMoreClicks(readMoreLink);
    });
  });
};

const debounce = (mainFunction, delay) => {
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      mainFunction(...args);
    }, delay);
  };
};

const trackReadMoreClicks = (target) => {
  // safety navigator added as tracking in development is disabled and this can cause unwanted errors
  window?.snowplowHelper?.trackFrontofficeStructEvent({
    category: "marketing",
    action: "ai_trade_selector_trade_definition_read_more_clicked",
    label: "ai_trade_selector_trade_definition",
    property: target.closest(".radio-label").querySelector(".trade-name")
      .innerText,
    serviceChannelIdentifier: $('meta[name="site"]').attr("content"),
  });
};
